import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import _ from 'lodash'; // import cx from 'classnames'

import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import Progress from './ui/react-ui/progress.jsx';
import DateRange from './ui/react-ui/date-range';
import Statistic from './trafficStatistic/statistic'; // api

import { getTrafficTerminalLine, getTrafficZoneVisit, getTrafficTerminalLineByDay, getTrafficZoneVisitByDay, getTrafficRoadSectionByDay } from '../api/predictionAPI';
import { getAreaTerminals, getAreaZones } from '../api/areaAPI';
import { getVdsGeographic } from '../api/deviceAPI'; // redux

import { setTerminalTrendChartData, setAreaTrendChartData, setHeatmapMarkers, setRoadSectionChartData, reset } from '../redux/traffic-statistic';
var t = i18n.getFixedT(null, 'traffic-statistic');
var gt = i18n.getFixedT(null, 'app');
var TrafficStatistic = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      mapBounds = _useSelector.trafficStatistic.mapBounds;

  var dispatch = useDispatch();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      dateTime = _useState2[0],
      setDateTime = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCloseDateRange = _useState4[0],
      setIsCloseDateRange = _useState4[1];

  var initDateTime = {
    from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
    to: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm')
  };
  var id = props.id;
  var isMounted = useRef(false); // const beforeDateTime = useRef(initDateTime)
  // const isChange = useRef(false)

  var handleChangeDateTime = function handleChangeDateTime(dateTime) {
    setDateTime(dateTime);
  }; // const handleCloseDateRange = value => {
  //     if(_.isEqual(beforeDateTime.current, value))
  //         return
  //     setIsCloseDateRange(!isChange.current)
  // }


  var fetchData = function fetchData() {
    Progress.startSpin(); // terminal
    // const getTrafficTerminalLineByDay_api = getTrafficTerminalLineByDay(contextRoot, true, _.isEmpty(dateTime) ? initDateTime : dateTime)

    var getTrafficTerminalLine_api = getTrafficTerminalLine(contextRoot, true, _.isEmpty(dateTime) ? initDateTime : dateTime);
    var getTerminals_api = getAreaTerminals(contextRoot, true); // zone
    // const getTrafficZoneVisitByDay_api = getTrafficZoneVisitByDay(contextRoot, true, _.isEmpty(dateTime) ? initDateTime : dateTime)

    var getTrafficZoneVisit_api = getTrafficZoneVisit(contextRoot, true, _.isEmpty(dateTime) ? initDateTime : dateTime);
    var getAreaZones_api = getAreaZones(contextRoot, true); // road section

    var getTrafficRoadSectionByDay_api = getTrafficRoadSectionByDay(contextRoot, true, _.isEmpty(dateTime) ? initDateTime : dateTime);
    $.when(getTrafficTerminalLine_api, getTerminals_api, getTrafficZoneVisit_api, getAreaZones_api, getTrafficRoadSectionByDay_api).then(function (ttlbd_result, terminals_result, tzvbd_result, zones_result, roadSection_result) {
      // Handle ttlbd chart data
      var terminalTrendChartData = {};

      _.map(ttlbd_result.content, function (el) {
        var terminal = _.find(terminals_result.content, function (e) {
          return e.id === el.terminalId;
        });

        var name = terminal.name + '-' + t("lbl-".concat(el.deliverType.toUpperCase()));
        terminalTrendChartData[name] = [];
        var item = terminalTrendChartData[name];

        _.forEach(el.stats, function (o) {
          item.push({
            time: moment(o.dateTime).format('YYYY-MM-DD HH:mm'),
            value: _.round(o.avgTrailerLineQty, 1)
          });
        });
      });

      dispatch(setTerminalTrendChartData(terminalTrendChartData)); // Handle tzvbd chart data

      var zoneVisitByDayData = {};

      _.map(tzvbd_result.content, function (el) {
        var zone = _.find(zones_result.content, function (e) {
          return e.id === el.zoneId;
        });

        var name = zone.name + '-' + t("lbl-".concat(el.visitType.toUpperCase()));
        zoneVisitByDayData[name] = [];
        var item = zoneVisitByDayData[name];

        _.forEach(el.stats, function (o) {
          item.push({
            time: moment(o.dateTime).format('YYYY-MM-DD HH:mm'),
            value: _.round(o.totalTrailerLineQty, 1)
          });
        });
      });

      dispatch(setAreaTrendChartData(zoneVisitByDayData)); // road section

      dispatch(setRoadSectionChartData(roadSection_result.content));
      Progress.done();
    }).catch(function (error) {
      console.log(error);
      Progress.done();
    });
  };

  useEffect(function () {
    if (!isMounted.current && _.isEmpty(mapBounds)) return;
    var latLngStart = mapBounds._southWest,
        latLngEnd = mapBounds._northEast;
    getVdsGeographic(contextRoot, true, latLngStart, latLngEnd).then(function (result) {
      var heatmapMarkers = _.map(result.content, function (el) {
        return {
          x: el.longitude,
          y: el.latitude,
          value: el.congestionStatus
        };
      });

      dispatch(setHeatmapMarkers(heatmapMarkers));
    });
  }, [JSON.stringify(mapBounds)]); // useEffect(() => {
  //     if(!isMounted.current)
  //         return
  //     isChange.current = isCloseDateRange
  //     beforeDateTime.current = dateTime
  //     fetchData()
  // }, [JSON.stringify(isCloseDateRange)])

  useEffect(function () {
    if (!isMounted.current) {
      fetchData();
      isMounted.current = true;
    }

    var flatpickerTime = document.getElementsByClassName('flatpickr-time time24hr');

    _.forEach(flatpickerTime, function (el) {
      return el.style.display = 'none';
    });

    return function () {
      dispatch(reset());
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "traffic-statistic-headBar"
  }, /*#__PURE__*/React.createElement(DateRange, {
    id: "datetime",
    enableTime: true,
    enableStartEndLabel: true,
    startLabel: t('lbl-start-time'),
    endLabel: t('lbl-end-time'),
    allowKeyIn: false,
    onChange: handleChangeDateTime // onClose={handleCloseDateRange}
    ,
    defaultValue: initDateTime,
    value: dateTime,
    limitRange: '30d' // t={(code, params) => {
    //     if (code === 'missing')
    //         return `Please input date`
    //     else {
    //         return `Invalid date format. Should be ${params.pattern}`
    //     }
    // }}

  }), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return fetchData();
    }
  }, gt('global.lbl-search'))), /*#__PURE__*/React.createElement("div", {
    className: "statistic-content"
  }, /*#__PURE__*/React.createElement(Statistic, null)));
});
TrafficStatistic.defaultProps = {
  id: 'g-traffic-statistic'
};
TrafficStatistic.propTypes = {
  id: PropTypes.string
};
export default TrafficStatistic;